export const BRAND = {
  logoDark: "https://customer-assets.emergentagent.com/job_zentry-aman-build/artifacts/d1pu6yic_Zentry.png",
  logoBlue: "https://customer-assets.emergentagent.com/job_zentry-aman-build/artifacts/d1pu6yic_Zentry.png",
  founder: "https://customer-assets.emergentagent.com/job_6993a711-096d-402d-ac9f-a136040153be/artifacts/fwpmee0k_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2012_52_55%20PM.png",
  heroBg: "https://static.prod-images.emergentagent.com/jobs/6993a711-096d-402d-ac9f-a136040153be/images/a3711259406dd8116dc3baacecc7382470a88b393aca898001ae8914afe6a72c.png",
  trustTexture: "https://static.prod-images.emergentagent.com/jobs/6993a711-096d-402d-ac9f-a136040153be/images/f0cf433789cf5cf33076de653d0e5035352fa34608de22b378637f64078f3e8a.png",
  holidayImages: [
    "https://images.unsplash.com/photo-1582610116397-edb318620f90?auto=format&fit=crop&q=80&w=1600",
    "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&q=80&w=1600",
    "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&q=80&w=1600",
  ],
  plotsImages: [
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80&w=1600",
    "https://images.unsplash.com/photo-1500076656116-558758c991c1?auto=format&fit=crop&q=80&w=1600",
  ],
  contact: {
    email: "clarity@getzentry.in",
    instagram: "getzentry.in",
    instagramUrl: "https://instagram.com/getzentry.in",
    youtube: "zentryrealestate",
    youtubeUrl: "https://youtube.com/@zentryrealestate",
    whatsapp: "https://wa.me/919999999999",
  },
  founderName: "Aman Thukral",
};
